import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetCompanyDto';

import { CompanyEndPackageLink } from './CompanyEndPackageLink';
import { CompanyInvoicesLink } from './CompanyInvoicesLink';

interface CompanySearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
  withFilterInColumns?: boolean;
}

export const companyForGrid = (company: GetCompanyDto) => {
  return {
    key: company.id,
    values: {
      'company.name': company.name,
      'company.nip': company.nip,
      'taxCountryCode.value': company.taxCountryCode?.value,
      'company.email': company.email,
      'company.monthlySettlement': company.monthlySettlement ? 'Tak' : '',
      'company.invoicesSettlement': company.invoicesSettlement ? 'Tak' : '',
      'company.autoInvoice': company.autoInvoice ? 'Tak' : '',
      'company.externalReferral': company.externalReferral ? 'Tak' : 'Nie',
      'branch.name': company?.branch?.name,
      'healthcareFacility.displayName':
        company?.healthcareFacility?.displayName,
      'battery.name': company?.companiesBatteries
        ?.map(o => o?.battery?.name)
        .join(', '),
      'company.active': company.active ? 'Tak' : 'Nie',
      endPackage: (
        <CompanyEndPackageLink
          companyId={company.id}
          companyName={company.name}
        />
      ),
      invoices: (
        <CompanyInvoicesLink
          companyId={company.id}
          companyName={company.name}
        />
      ),
    },
  };
};

export const CompanySearch: React.FC<CompanySearchProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'company.name' },
    { header: 'NIP', property: 'company.nip' },
    { header: 'Kod kraju', property: 'taxCountryCode.value' },
    { header: 'Email', property: 'company.email' },
    {
      header: 'Rozliczana miesięcznie',
      property: 'company.monthlySettlement',
      noFilter: true,
    },
    {
      header: 'Rozliczana wg faktur',
      property: 'company.invoicesSettlement',
      noFilter: true,
    },
    {
      header: 'Automatyczne fakturowanie',
      property: 'company.autoInvoice',
      noFilter: true,
    },
    {
      header: 'Skierowania w systemie',
      property: 'company.externalReferral',
      noFilter: true,
    },
    { header: 'Firma nadrzędna', property: 'branch.name' },
    { header: 'Placówka', property: 'healthcareFacility.displayName' },
    {
      header: 'Przypisane baterie',
      property: 'battery.name',
      noSorting: false,
    },
    {
      header: 'Aktywna',
      property: 'company.active',
      noSorting: false,
      noFilter: true,
    },
    {
      header: '',
      property: 'endPackage',
      noSorting: true,
      noFilter: true,
    },
    {
      header: '',
      property: 'invoices',
      noSorting: true,
      noFilter: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      withFilterInColumns={props.withFilterInColumns}
      initialOrderColumn="company.name"
      initialOrderDirection="ASC"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak firm w systemie"
      refresh={props.refresh}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
      showExport={true}
    />
  );
};
